module.exports = __webpack_public_path__ + "img/vscode.73f294d7.svg";